<template lang="pug">
  .auth--confirm
    //- Success confirm
    .text--center(v-if="success")
      van-icon(name="succes")
      h1 {{ $t('messages.validateEmail.title')}}
      p {{ $t('messages.validateEmail.message')}}

    //- Fails confirm
    .text--center(v-if="fails")
      van-icon(name="error")
      h1 {{ $t('errors.expireEmail.title')}}
      p {{ $t('errors.expireEmail.message')}}

    //- Succes send email confirm
    .text--center(v-if="successSendEmail")
      van-icon(name="succes")
      h1 {{ $t('messages.resendToken.title')}}
      p {{ $t('messages.resendToken.message')}}

    //- Fails send email confirm
    .text--center(v-if="failsSendEmail")
      van-icon(name="error")
      h1 {{ $t('errors.general.title')}}
      p {{ $t('errors.general.message')}}

    form.auth__form(@submit.prevent="sendEmailConfirm"
      v-if="!success")
      input(
        type="email"
        name="email"
        v-model="email"
        v-validate="'required|email'"
        :data-vv-as="$t('auth.form.email')"
        :class="{'error': errors.has('email') }"
        :placeholder="$t('auth.form.email')")

      .margin-halve-top
        .auth__error(v-show="errors.has('email')") {{ errors.first('email') }}

      van-button(
        size="large"
        type="primary"
        native-type="submit") {{ $t('auth.form.send')}}

</template>

<script>
import i18n from '@/locales/i18n';
import UserService from '@/services/user.service';

export default {
  data() {
    return {
      email: '',
      error: '',
      success: false,
      fails: false,
      successSendEmail: false,
      failsSendEmail: false,
      isLoading: false,
    };
  },
  methods: {
    sendEmailConfirm() {
      // Compruebo si hay una petición en curso,
      // si la hay, no hago nada
      if (this.isLoading) return;

      this.clearMessages();

      this.$validator.validateAll().then(async result => {
        if (result) {
          this.isLoading = true;

          // Muestro el loader
          this.$toast.loading({
            duration: 0,
            mask: true,
            message: i18n.t('general.loading'),
          });

          try {
            await UserService.sendConfirmEmail(this.email);
            this.$toast.clear();
            this.isLoading = false;
            this.successSendEmail = true;
          } catch (error) {
            console.log(error);
            this.$toast.clear();
            this.isLoading = false;
            this.failsSendEmail = true;
          }
        }
      });
    },

    clearMessages() {
      this.success = false;
      this.successSendEmail = false;
      this.fails = false;
      this.failsSendEmail = false;
      this.error = '';
    },
  },

  async created() {
    this.isLoading = true;

    // Muestro el loader
    this.$toast.loading({
      duration: 0,
      mask: true,
      message: i18n.t('general.loading'),
    });

    const { token } = this.$route.params;

    console.log(token);

    try {
      await UserService.confirm(token);
      this.isLoading = false;
      this.$toast.clear();
      this.success = true;
    } catch (error) {
      console.log(error);
      this.isLoading = false;
      this.$toast.clear();
      this.fails = true;
    }
  },
};
</script>
